import bindEvent from '../../scripts/util/event/bindEvent';
import isElement from '../../scripts/util/DOM/isElement';
import {forEach} from 'ramda';
const selectors = {
	btn: '.js-events-more',
	wrapper: '.js-events-wrapper',
	content: '.js-events',
	item: '.js-events-item'
};

const states = {
	hidden: 'hidden'
};

const showMore = el => el.classList.remove(states.hidden);

const hideBtn = btn => {
	const parent = btn.parentElement;
	parent.classList.add(states.hidden);
};

const checkBtnNeed = item => {
	const hiddenItems = item.querySelectorAll(`${selectors.item}.${states.hidden}`);
	const btn = item.nextElementSibling;
	if (!hiddenItems.length) {
		btn.classList.add(states.hidden);
	}
};

const onClick = e => {
	const target = e.currentTarget;
	const wrapper = target.closest(selectors.wrapper);
	const content = wrapper.querySelector(selectors.content);
	const hiddenItems = content.querySelectorAll(`${selectors.item}.${states.hidden}`);
	const hiddenItem = hiddenItems[0];
	if (hiddenItems.length > 1) {
		showMore(hiddenItem);
	}else {
		showMore(hiddenItem);
		hideBtn(target);
	}
};

const onLoad = () => {
	const events = document.querySelectorAll(selectors.content);
	forEach(checkBtnNeed)(events);
};

const setHandlers = () => {
	window.addEventListener('load', onLoad);
	bindEvent(selectors.btn, 'click', onClick);
};

const render = () => {
	if (isElement(selectors.btn)) {
		setHandlers();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/events/index.js